import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, Pagination, Table, TableHeader, TableCell, TableLoading } from 'advenio-components'
import DomiciliationReportActions from '../../Data/Redux/DomiciliationReportRedux'
import { stringContainsExactlyOf } from '../../utils/Utils'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 16px;
  width: 100%;
`

const ExportContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 16px;
`

const EmptyState = styled.div`
  width: 100%;
  padding: 32px;
  text-align: center;
  color: #757575;
  font-size: 16px;
`

const TableContainer = styled.div`
  width: 100%;
`

const PaginationContainer = styled.div`
  margin: 12px 0;
`

class DomiciliationReport extends Component {
  state = {
    pageSelected: 1,
  }

  componentWillMount() {
    const { centerId, isBackOffice, getReport, getAllReport } = this.props

    if (isBackOffice) {
      getAllReport(1)
    } else if (centerId) {
      getReport(centerId)
    }
  }

  onClickPage = (page) => {
    const { getAllReport } = this.props
    this.setState({ pageSelected: page })
    getAllReport(page)
  }

  export = () => {
    const { centerId, isBackOffice, exportReport, exportAllReport } = this.props

    if (isBackOffice) {
      exportAllReport()
    } else if (centerId) {
      exportReport(centerId)
    }
  }

  getColumns = () => {
    const { isBackOffice } = this.props

    const columns = []

    if (isBackOffice) {
      columns.push({
        id: 'center',
        Header: () => <TableHeader title="Centro" blue />,
        Cell: ({ original: { center_name } }) => (
          <TableCell>{center_name || '-'}</TableCell>
        ),
        maxWidth: 180,
      })
    }

    columns.push(
      {
        id: '1',
        Header: () => <TableHeader title="Alumno" blue />,
        Cell: ({ original: { student_name } }) => (
          <TableCell>{student_name || '-'}</TableCell>
        ),
      },
      {
        id: '2',
        Header: () => <TableHeader title="Padre/Tutor" blue />,
        Cell: ({ original: { parent_name } }) => (
          <TableCell>{parent_name || '-'}</TableCell>
        ),
      },
      {
        id: '3',
        Header: () => <TableHeader title="Últimos 4 dígitos" blue />,
        Cell: ({ original: { card_last_four } }) => (
          <TableCell>{card_last_four || '-'}</TableCell>
        ),
        maxWidth: 160,
      },
      {
        id: '4',
        Header: () => <TableHeader title="Marca tarjeta" blue />,
        Cell: ({ original: { card_brand } }) => (
          <TableCell>{card_brand || '-'}</TableCell>
        ),
        maxWidth: 140,
      },
      {
        id: '5',
        Header: () => <TableHeader title="Fecha activación" blue />,
        Cell: ({ original: { activated_at } }) => (
          <TableCell>{activated_at || '-'}</TableCell>
        ),
        maxWidth: 160,
      },
      {
        id: '6',
        Header: () => <TableHeader title="Última transacción" blue />,
        Cell: ({ original: { last_transaction_status } }) => (
          <TableCell>{last_transaction_status || '-'}</TableCell>
        ),
        maxWidth: 180,
      },
      {
        id: '7',
        Header: () => <TableHeader title="Monto última transacción" blue />,
        Cell: ({ original: { last_transaction_amount } }) => (
          <TableCell>{last_transaction_amount != null ? last_transaction_amount : '-'}</TableCell>
        ),
        maxWidth: 200,
      },
      {
        id: '8',
        Header: () => <TableHeader title="Fecha última transacción" blue />,
        Cell: ({ original: { last_transaction_date } }) => (
          <TableCell>{last_transaction_date != null ? last_transaction_date : '-'}</TableCell>
        ),
        maxWidth: 200,
      },
    )

    return columns
  }

  renderTable = () => {
    const { fetching, data } = this.props

    if (fetching) {
      return (
        <TableLoading
          curvedTop
          rows={5}
          columns={this.getColumns()}
        />
      )
    }

    if (!data || data.length === 0) {
      return <EmptyState>Sin registros de domiciliación</EmptyState>
    }

    return (
      <Table
        roundedCorners
        data={data}
        columns={this.getColumns()}
      />
    )
  }

  render() {
    const { exportFetching, isBackOffice, meta } = this.props
    const { pageSelected } = this.state

    return (
      <Container>
        <ExportContainer>
          <Button
            marginRight="0"
            marginLeft="0"
            danger
            small
            onClick={this.export}
            loading={exportFetching}
          >
            Descargar
          </Button>
        </ExportContainer>
        {isBackOffice && meta && (
          <PaginationContainer>
            <Pagination
              totalElements={meta.total}
              elementsPerPage={meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
        )}
        <TableContainer>
          {this.renderTable()}
        </TableContainer>
      </Container>
    )
  }
}

const mapStateToProps = ({ centersInfo, domiciliationReport, auth }) => {
  const isBackOffice = stringContainsExactlyOf(auth.user.role, ['Back Office Admin', 'Back Office MiAdvenio', 'Back Office Talisis', 'Super Admin'])

  return {
    centerId: centersInfo.center || auth.user.center_id,
    isBackOffice,
    data: domiciliationReport.get.results && domiciliationReport.get.results.data
      ? domiciliationReport.get.results.data
      : [],
    meta: domiciliationReport.get.results
      ? domiciliationReport.get.results.meta
      : null,
    fetching: domiciliationReport.get.fetching,
    exportFetching: domiciliationReport.export.fetching,
  }
}

const mapDispatchToProps = dispatch => ({
  getReport: centerId => dispatch(DomiciliationReportActions.getRequest(centerId)),
  getAllReport: (page) => dispatch(DomiciliationReportActions.getAllRequest(page)),
  exportReport: centerId => dispatch(DomiciliationReportActions.exportRequest(centerId)),
  exportAllReport: () => dispatch(DomiciliationReportActions.exportAllRequest()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DomiciliationReport))



// WEBPACK FOOTER //
// ./src/Containers/Reports/DomiciliationReport.jsx